import {
  HTMLChakraProps,
  TableBodyProps,
  TableCellProps,
  TableHeadProps,
  TableProps,
  TableRowProps,
} from '@chakra-ui/react';
import customTheme from '~/styles/theme';

export const TableWrapStyle: TableProps = {
  border: `1px solid ${customTheme.colors.primary['100']}`,

  __css: {
    '& > div': {
      overflow: 'auto hidden',
    },
  },
};

export const TableStyle: TableProps = {
  borderRadius: '12px',
  overflowX: 'auto',
  width: '100%',
  maxWidth: '100%',
};

export const TableHeader: TableHeadProps = {
  backgroundColor: customTheme.colors.neutral['100'],
  borderBottom: `1px solid ${customTheme.colors.primary['100']}`,
  height: '2.75rem',
};

export const ColumnHeader = {
  backgroundColor: customTheme.colors.neutral['100'],
  borderRadius: '12px',
};

export const HeaderTextStyleProps: HTMLChakraProps<'div'> = {
  fontWeight: 500,
  fontSize: 'sm',
  textAlign: 'left',
  lineHeight: '10px',
  color: customTheme.colors.primary['400'],
};

export const TableHeaderText: (opt: {
  onHoverEffect: boolean;
  noPadding?: boolean;
}) => HTMLChakraProps<'div'> = ({ onHoverEffect, noPadding }) => ({
  ...HeaderTextStyleProps,
  height: '2.75rem',
  padding: noPadding ? '0' : '0px 16px',
  backgroundColor: customTheme.colors.neutral['100'],
  ...(onHoverEffect && {
    cursor: 'pointer',
    _hover: {
      backgroundColor: customTheme.colors.neutral['200'],
    },
    _active: {
      backgroundColor: customTheme.colors.primary['200'],
    },
  }),
  _focusVisible: {
    backgroundColor: customTheme.colors.neutral['200'],
  },
});

export const TableTrStyle: TableRowProps = {
  _last: {
    borderWidth: '0px',
    '& > td': {
      borderWidth: 0,
    },
  },
  _first: {
    '& > th': {
      borderRadius: '12px!important',
    },
  },
  _hover: {
    '& > td': { backgroundColor: customTheme.colors.neutral['100'] },
  },
  _active: {
    '& > td': { backgroundColor: customTheme.colors.neutral['100'] },
  },
  _focusVisible: {
    '& > td': {
      backgroundColor: customTheme.colors.neutral['100'],
    },
  },
};

export const TableBodyStyle: TableBodyProps = {
  backgroundColor: customTheme.colors.white,
};

export const TableTdStyle: (zindex?: number) => TableCellProps = (zindex) => ({
  border: 'none',
  backgroundColor: customTheme.colors.white,
  _first: {
    position: 'sticky',
    left: 0,
    zIndex: zindex || 1,
  },
});
export const TableThStyle = {
  _first: {
    backgroundColor: customTheme.colors.neutral['100'],
    position: 'sticky',
    left: 0,
    zIndex: 3,
  },
};

export const TableCellShadow: TableCellProps = {
  zIndex: 1,
  height: '100%',
  position: 'absolute',
  right: '0',
  top: 0,
  width: '100%',
  boxShadow: '0px 0px 13px 5px rgba(0, 0, 0, 0.03)',
  clipPath: 'inset(0px -18px 0px 0px)',
};
